function workOrders(state = [], action) {
  switch (action.type) {
    case "RECEIVE_WORKORDERS":
      // console.log(action);
      return [...action.workOrders];
    case "@@router/LOCATION_CHANGE":
      return [];
    case "LOGGING_OUT":
      return [];
    default:
      return state;
  }
}

export default workOrders;



// WEBPACK FOOTER //
// ./app/reducers/workOrders.js